export default "__VITE_ASSET__BrgPJkL4__"